import { AppConsts } from '../AppConsts';
import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { VendorDto } from 'src/app/proxy/vendors';
import { UserVendorService as UserVendorServiceProxy } from 'src/app/proxy/user-vendors';

@Injectable({
    providedIn: 'root'
})
export class UserVendorService {
    private currentVendor: VendorDto;
    private currentVendorsAvailables: VendorDto[];

    constructor(
        private readonly _userVendorService: UserVendorServiceProxy
    ) {
        this.addRefreshEventListener();
    }

    async getCurrentUserVendor(): Promise<VendorDto> {
        if (this.currentVendor) {
            return this.currentVendor;
        }

        const userVendorInformation = await firstValueFrom(this._userVendorService.getCurrentUserVendor());

        this.currentVendor = userVendorInformation;
        return this.currentVendor;
    }

    async getCurrentUserPlaceBasicInformation(): Promise<VendorDto> {
        if (this.currentVendor) {
            return this.currentVendor;
        }

        const userPlaceInformation = await firstValueFrom(this._userVendorService.getCurrentUserVendor());

        this.currentVendor = userPlaceInformation;
        return this.currentVendor;
    }

    async getUserPlaceAvailables(): Promise<VendorDto[]> {
        if (this.currentVendorsAvailables) {
            return this.currentVendorsAvailables;
        }

        this.currentVendorsAvailables = await firstValueFrom(this._userVendorService.getCurrentUserAvailableVendors());
        return this.currentVendorsAvailables;
    }

    refreshCurrentUserVendor(): void {
        localStorage.setItem(AppConsts.RefreshTabsEvent, JSON.stringify(new Date()));
        location.reload();
    }
    
    private addRefreshEventListener(): void {
        addEventListener(AppConsts.LocalStorageKey, this.refreshOnLocationChange);
    }
    
    private refreshOnLocationChange(event: StorageEvent): void {
        if (event.key === AppConsts.RefreshTabsEvent && event.newValue) {
            localStorage.removeItem(AppConsts.RefreshTabsEvent);
            location.reload();
        }
    }
}